module.exports = __webpack_public_path__ + "img/GameConsole-right.c22c24df.png";